import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import ChangeCheckContext from "../support/ChangeCheckContext";
import Row from "react-bootstrap/Row";

function ColorInput(props) {

    const {disable} = React.useContext(ChangeCheckContext)

    function handleChange(event) {
        props.onChange({target: {name: props.name, value: event.target.value}})
    }

    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className="mb-3 flex-row">
                <Form.Control
                    disabled={disable}
                    type="color"
                    value={props.value}
                    onChange={handleChange}
                    style={{"margin-right": "10px"}}
                />
                <label>
                    {props.value}
                </label>
            </InputGroup>
        </>
    )
}

export default ColorInput
